import { Formatter } from 'angular-slickgrid';
import { extractDateOnlyParts } from '../../utils/date-only-value';

function padDatePart(value: number | string): string {
  return String(value).padStart(2, '0');
}

function formatDateParts(day: number | string, month: number | string, year: number | string): string {
  return `${padDatePart(day)}/${padDatePart(month)}/${year}`;
}

function formatDateObject(value: Date): string {
  if (Number.isNaN(value.getTime())) {
    return '';
  }

  return formatDateParts(value.getDate(), value.getMonth() + 1, value.getFullYear());
}

export const dateOnlyFormatter: Formatter = (_row, _cell, value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  if (typeof value === 'string') {
    const dateParts = extractDateOnlyParts(value);
    if (dateParts) {
      return formatDateParts(dateParts.day, dateParts.month, dateParts.year);
    }
  }

  const parsedDate = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return String(value);
  }

  return formatDateObject(parsedDate);
};
